<template>
  <div class="ui-select">
    <p class="value">at Canmbridge</p>
    <ul class="list">
      <li></li>
    </ul>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="scss" scoped>
.ui-select{display: inline-block; vertical-align: middle;}
.value{
  height: 42px; min-width: 130px; border-radius: 42px; line-height: 42px; padding: 0 65px 0 24px; position: relative; background: #ededed; cursor: pointer;
  &:after{content: ''; position: absolute; width: 22px; height: 12px; top: 15px; right: 23px; background: url(../assets/arrow_down.png);}
}
</style>